<template>
  <div class="contactus-page">
    <div class="container-fluid">
      <div class="row ptb-2">
        <div class="col-lg-6 px-0 px-lg-3">
          <div class="bg-row"></div>
          <div class="mx-3">
            <div class="get-start-box px-lg-5 px-3 pt-2 pb-5 mx-lg-0">
              <div>
                <div class="text-center mb-3 mt-5">
                  <!-- <img
                    src="@/assets/imgs/ContactUsNew1.jpeg"
                    class="img-fluid"
                  /> -->
                  <img
                    src="@/assets/imgs/Illustration 13@1x.png"
                    class="img-fluid"
                  />
                </div>
                <!-- <h2
                  class="main-heading-2 text-center mt-5"
                  style="font-weight: bolder"
                >
                  Get started with us!
                </h2> -->
                <p class="main-content-1 text-center">
                  Get Started with Us When planning to study abroad, you may
                  have questions, such as: <br /><br />

                  Will I get into my dream university?<br />
                  How will I survive on my own without family? <br />
                  What can I do to get into a top college?<br />
                  Will I be able to afford studying abroad? <br /><br />

                  We are here to offer solutions to your study abroad queries
                  with attention and utmost care. Fill out the form below to
                  help us understand your concerns in detail, and an expert from
                  our team will be in touch with you soon.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-5 py-lg-5 my-lg-5 contact-min-height">
          <div class="pl-4 mb-4 d-none d-md-block">
            <h2 class="main-heading-2">
              Your global career awaits. Click to start your journey to success
            </h2>
            <p class="main-content-1">
              Fill the form below, and our team of experts will promptly
              address your queries.
            </p>
          </div>
          <!-- <form @submit.prevent="formSubmit"> -->
          <form :action="'https://formsubmit.co/' + mail_to" method="POST">
            <div class="contact-accordion" role="tablist">
              <div no-body visible class="accordion-box">
                <div block v-b-toggle.collapse-1 class="accordion-btn">
                  I'm a...
                </div>
                <b-collapse id="collapse-1" visible>
                  <div class="accordion-body">
                    <div>
                      <b-form-radio-group
                        class="custom-checkbox-btns"
                        @change="onSelectIam"
                        :options="[
                          'Student',
                          'Parent',
                          'Indian Institute',
                          'Foreign Institute',
                        ]"
                        name="i_am"
                        id="i_am_id"
                        button-variant="outline-primary"
                        buttons
                      >
                      </b-form-radio-group>
                    </div>
                  </div>
                </b-collapse>
              </div>
              <div no-body visible class="">
                <div block v-b-toggle.collapse-2 class="accordion-btn">
                  I’m interested in...
                </div>
                <b-collapse id="collapse-2" visible>
                  <div class="accordion-body custom-form-control">
                    <div class="pb-lg-5 pb-3">
                      <b-form-checkbox-group
                        class="custom-checkbox-btns"
                        :options="['Career counselling', 'Other Enquiry']"
                        name="interested_in"
                        id="interested_in_id"
                        button-variant="outline-primary"
                        buttons
                      ></b-form-checkbox-group>
                    </div>
                    <div>
                      <b-collapse id="collapse-3" visible>
                        <!-- <div
                          class="accordion-body custom-form-control contact-custom-form-control-pad"
                        >
                          <div class="form-spacing">
                            <label
                              >What is your child’s current high school?</label
                            >
                            <input
                              name="High School Name"
                              id="name_id"
                              type="text"
                              class="form-control"
                              placeholder="Enter your child’s current school..."
                              required
                            />
                          </div>
                          <div class="form-spacing">
                            <label
                              >What is your child’s current high school?</label
                            >
                            <input
                              name="High School Name"
                              id="name_id"
                              type="text"
                              class="form-control"
                              placeholder="Enter your child’s current school..."
                              required
                            />
                          </div>
                          <div class="form-spacing">
                            <label
                              >What is your child’s current high school?</label
                            >
                            <input
                              name="High School Name"
                              id="name_id"
                              type="text"
                              class="form-control"
                              placeholder="Enter your child’s current school..."
                              required
                            />
                          </div>
                        </div> -->
                      </b-collapse>
                    </div>
                  </div>
                </b-collapse>
              </div>
              <div no-body visible class="">
                <div block v-b-toggle.collapse-3 class="accordion-btn">
                  My contact information is...
                </div>
                <b-collapse id="collapse-3" visible>
                  <div class="accordion-body custom-form-control">
                    <div class="form-spacing">
                      <label>First Name:</label>
                      <input
                        name="Name"
                        id="first_id"
                        type="text"
                        class="form-control"
                        placeholder="Enter your first name"
                        required
                      />
                    </div>
                    <div class="form-spacing">
                      <label>Last Name:</label>
                      <input
                        name="Name"
                        id="last_id"
                        type="text"
                        class="form-control"
                        placeholder="Enter your last name"
                        required
                      />
                    </div>
                    <div class="form-spacing">
                      <label>Email:</label>
                      <input
                        name="Email"
                        id="email_id"
                        type="email"
                        class="form-control"
                        placeholder="Enter your Email"
                        required
                      />
                    </div>
                    <div class="form-spacing">
                      <label>Phone Number:</label>
                      <input
                        name="Contact"
                        id="contact_id"
                        type="phno"
                        class="form-control"
                        placeholder="Enter your phone number"
                        required
                      />
                    </div>
                    <div class="form-spacing">
                      <label>Message:</label>
                      <textarea
                        name="Message"
                        id="message_id"
                        type="phno"
                        class="form-control"
                        placeholder="Enter your Message"
                        required
                      />
                    </div>
                    <!-- <div class="form-spacing">
                      <label>What city and country are you from:</label>
                      <input
                        name="City"
                        id="_id"
                        type="text"
                        class="form-control"
                        placeholder="Enter your City"
                        required
                      />
                    </div>
                    <div class="form-spacing">
                      <label>Student’s first name :</label>
                      <input
                        name="Country"
                        id="country_id"
                        type="text"
                        class="form-control"
                        placeholder="Enter your Country"
                        required
                      />
                    </div>
                    <div class="form-spacing">
                      <label>Student’s last name :</label>
                      <input
                        name="Country"
                        id="country_id"
                        type="text"
                        class="form-control"
                        placeholder="Enter your Country"
                        required
                      />
                    </div>
                    <div class="form-spacing mb-2">
                      <label>Student’s email name :</label>
                      <input
                        name="Country"
                        id="country_id"
                        type="text"
                        class="form-control"
                        placeholder="Enter your Country"
                        required
                      />
                    </div> -->
                    <!-- <div class="form-spacing">
                      <div class="radio-1 mb-2">
                        <input type="radio" name="terms" />
                        <span
                          >I agree to the
                          <a href="#"> <u>privacy policy.</u></a></span
                        >
                      </div>
                      <div class="radio-2">
                        <input type="radio" name="terms" />
                        <span
                          >I want to receive study pathways, free resources and
                          admissions guidance from Crimson Education Group and
                          QS Group.</span
                        >
                      </div>
                    </div> -->
                  </div>
                </b-collapse>
              </div>
            </div>

            <div class="mt-3 pl-4">
              <button type="submit" class="btn btn-secondary-red">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ContactUs",
    metaInfo: {
      title: "Contact Aliff Overseas | Foreign Education Consultancy",
      htmlAttrs: {
        lang: "en-US",
      },
      meta: [
        { charset: "utf-8" },
        {
          name: "description",
          content:
            "Aliff Overseas is determined to help students join top ranking international universities without wasting time or spending a fortune and worrying about their marks. Contact us today.",
        },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
      ],
    },
    data() {
      return {
        mail_to: "info@aliff.in",
        teamIntroSlider: {
          slidesToShow: 4.5,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: false,
          // autoplay: true,
          // autoplaySpeed: 0,
          // speed: 5000,
          // cssEase: "linear",
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
              },
            },
          ],
        },
      };
    },
    methods: {
      onSelectIam(val) {
        if (["Student", "Parent"].includes(val)) {
          this.mail_to = "info@aliff.in";
        } else {
          this.mail_to = "jenny@aliff.in";
        }
      },
      // formSubmit(e) {
      //   // console.log(e.target.value);

      //   const data = new FormData(e.target);
      //   const value = Object.fromEntries(data.entries());

      //   const mail_to = "https://formsubmit.co/";

      //   if (["I’am a student", "I’am a parent"].includes(value.i_am)) {
      //     mail_to = mail_to + "info@aliff.in";
      //   } else {
      //     mail_to = mail_to + "jenny@aliff.in";
      //   }

      //   fetch(`https://formsubmit.co/${mail_to}`, {
      //     method: "POST",
      //   });
      // },
    },
  };
</script>

<style>
  label.btn.btn-outline-primary.active {
    background: linear-gradient(135deg, #5367ff 0%, #00d09c 100%);
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/ContactUsNew.vue